module.exports = __webpack_public_path__ + "img/H2-2.png";